import React from 'react'
import HelpSlider from '../components/HelpSlider'

function Help() {
  return (
    <div>
      <HelpSlider />
    </div>
  )
}

export default Help